// Central content for the Mansie Himanshu Ranvah landing page
export const PROFILE = {
  name: "Mansie Himanshu Ranvah",
  shortName: "Mansie Ranvah",
  role: "Advocate · POSH Compliance Specialist",
  firm: "Ranvah Law Chambers",
  email: "mansi@ranvahlawchambers.net",
  phone: "+91 63502 33269",
  phoneHref: "+916350233269",
  portrait:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_85f27467-393e-4734-936a-527da9a057d6/artifacts/2qjee110_Mansie%20AD_-5.webp",
};

export const HERO = {
  overline: "POSH Act, 2013 · Compliance & Advisory",
  lines: ["Safe workplaces", "are not optional —", "they are the law."],
  intro:
    "I help institutions build genuinely safe, respectful and legally compliant workplaces — through POSH training, Internal Committee advisory and rigorous complaint redressal.",
  image:
    "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&w=1100&q=72",
  imageCaption: "POSH policy · Drafting & documentation",
};

export const MARQUEE_ITEMS = [
  "Certified POSH Trainer",
  "Authorized Trademark Agent",
  "ISO 9001",
  "ISO 27001:2022",
  "External IC Member",
  "8+ Years of Practice",
  "Founder · Ranvah Law Chambers",
];

export const ABOUT = {
  overline: "About",
  heading: "A lawyer who turns compliance into culture.",
  paragraphs: [
    "I am an Advocate and legal strategist with over eight years of practice advising startups, corporates and global teams. My core focus is POSH compliance — the Prevention of Sexual Harassment of Women at Workplace Act, 2013 — where I move organisations from box-ticking to genuine accountability.",
    "As a Certified POSH Trainer I have sensitised 360+ professionals, served as an External Internal Committee member for global employers, and presented final inquiry reports to management within a seven-day turnaround. Alongside POSH, I advise on intellectual property, contract risk and privacy compliance.",
  ],
  signature: "Mansie Himanshu Ranvah",
};

export const SERVICES = [
  {
    no: "01",
    title: "POSH Training & Sensitisation",
    desc: "Interactive, role-specific workshops for employees, managers and IC members — designed and delivered at scale. 360+ professionals trained across multiple batches.",
  },
  {
    no: "02",
    title: "Internal Committee (IC) Advisory",
    desc: "Constitution of a compliant Internal Committee, serving as External Member, and ongoing procedural guidance so your IC acts fairly, confidentially and within the law.",
  },
  {
    no: "03",
    title: "Complaint Redressal & Inquiry",
    desc: "End-to-end management of inquiries — from complaint intake to evidence, hearings and final reports to management — with a consistent seven-day turnaround.",
  },
  {
    no: "04",
    title: "Policy Drafting & Compliance Audit",
    desc: "Drafting of POSH policies, annual reporting, and audits that keep your organisation compliant with statutory obligations and ready for scrutiny.",
  },
];

export const MANIFESTO = {
  overline: "Why POSH compliance matters",
  chapters: [
    {
      no: "01",
      title: "It is a legal mandate.",
      body: "Every organisation with ten or more employees must constitute an Internal Committee and comply with the POSH Act, 2013. Non-compliance invites penalties, cancelled licences and reputational harm.",
    },
    {
      no: "02",
      title: "It builds a culture of safety.",
      body: "Compliance is the floor, not the ceiling. Real training changes how people behave — creating workplaces where every person feels respected, heard and secure.",
    },
    {
      no: "03",
      title: "It protects trust.",
      body: "A fair, confidential and prompt redressal process protects both complainants and the institution. Handled well, it becomes a signal of integrity to employees and clients alike.",
    },
  ],
};

export const STATS = [
  { value: "360+", label: "Professionals trained" },
  { value: "SHe-Box", label: "Registered on the portal" },
  { value: "7-day", label: "Average inquiry turnaround" },
  { value: "8+", label: "Years of legal practice" },
];

export const EXPERTISE = {
  overline: "Beyond POSH",
  heading: "Beyond POSH",
  intro:
    "Ranvah Law Chambers advises founders, corporates and HNIs across a focused set of commercial and regulatory practices — the same senior counsel, a wider mandate.",
  items: [
    {
      title: "IP & Trademark Strategy",
      desc: "Authorized Trademark Agent — 8+ trademarks filed for LVX and 4 pharma registrations secured with zero oppositions to date.",
    },
    {
      title: "Contract & Commercial Risk",
      desc: "190+ MSAs, SOWs and commercial contracts reviewed for U.S. clients; liability, indemnity and IP clauses restructured to cut exposure.",
    },
    {
      title: "Privacy & DPDP Compliance",
      desc: "DPDP Act mandates and GDPR principles embedded across privacy policies, MSAs and data-handling frameworks.",
    },
    {
      title: "Startup Deal Structuring",
      desc: "NBFC due diligence and investment transactions — Founders Agreements, SHA, SSA and ancillary deal documents.",
    },
    {
      title: "Estate & Legacy Planning",
      desc: "Wills drafted and registered; consultancy agreements and legacy planning for high-net-worth individuals.",
    },
    {
      title: "Regulatory & Entity Advisory",
      desc: "India market-entry strategy, entity structuring, transfer pricing and operational-risk counsel.",
    },
  ],
};

export const SERVICE_OPTIONS = [
  "POSH Training & Sensitisation",
  "Internal Committee (IC) Advisory",
  "Complaint Redressal & Inquiry",
  "Policy Drafting & Compliance Audit",
  "Other legal advisory",
];
